import { render, staticRenderFns } from "./BatchProduction.vue?vue&type=template&id=f4d25e96&scoped=true&"
import script from "./BatchProduction.vue?vue&type=script&lang=js&"
export * from "./BatchProduction.vue?vue&type=script&lang=js&"
import style0 from "./BatchProduction.vue?vue&type=style&index=0&id=f4d25e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d25e96",
  null
  
)

export default component.exports